import React from 'react';
import '../../src/bootstrap.css';
import Testimonial from '../components/Testimonial'


const Blog = () => {
 return (
  <>
   <h3 className="text-dark text-center mt-4">BLOG PAGE</h3>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   <Testimonial />
  </>
 )
}

export default Blog